import { render } from "./DashboardIbvk.vue?vue&type=template&id=80b34488&scoped=true"
import script from "./DashboardIbvk.vue?vue&type=script&lang=js"
export * from "./DashboardIbvk.vue?vue&type=script&lang=js"

import "./DashboardIbvk.vue?vue&type=style&index=0&id=80b34488&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b34488"]])

export default __exports__